<template>
    <div class="row panel-body">
        <form method="post" ref="form">
            <input type="hidden" name="_token" :value="csrfToken" />

            <div class="row">
                <div class="col-xs-1">

                </div>
                <div class="col-xs-3">
                    <h4 style="padding-left: 5px;">Master</h4>
                </div>

                <div class="col-xs-3">
                    <h4 style="padding-left: 5px;">Localization</h4>
                </div>

                <div class="col-xs-5">
                    <h4 style="padding-left: 5px;">Translated Localization</h4>
                </div>
            </div>

            <div class="subtitle-translated-localization-cue text-primary"
                 :class="{ 'bg-info': masterTitle !== localizedTitle }">
                <div class="row" :id="'diff-wrapper-title'">
                    <div class="col-xs-1" style="white-space: nowrap;">
                        <h2 class="inline">
                            Title
                        </h2>
                        <i class="fa lock"
                           v-if="this.masterTitle.trim() === this.localizedTitle.trim()"
                           :class="{ 'fa-lock': titleIsLocked, 'fa-unlock': !titleIsLocked }"
                           @click="toggleLock"
                        ></i>
                    </div>
                    <div class="col-xs-3">
                        <h2>
                            <p dir="auto" style="padding-bottom: 5px; line-height: 2em;" v-html="masterTitle"
                               :id="'original-title'"></p>
                            <p dir="auto" style="padding-bottom: 5px; line-height: 2em;" class="hide"
                               v-html="localizedTitle"
                               :id="'changed-title'"></p>
                        </h2>
                    </div>

                    <div class="col-xs-3">
                        <h2>
                            <div dir="auto" style="padding-bottom: 5px; line-height: 2em;" :class="'diff-title'"></div>
                        </h2>
                    </div>

                    <div class="col-xs-5">
                        <div :class="{ 'has-error': newTitle.trim() === '' }">
                            <h2>
                                <input class="form-control"
                                       style="color:black"
                                       type="text"
                                       @keyup="setCanSubmit()"
                                       placeholder="Translated Lesson Title"
                                       name="lesson_title"
                                       :required="true"
                                       :readonly="titleIsLocked"
                                       v-model="newTitle"
                                       id="lesson-title-translation" />
                            </h2>

                            <span class="help-block" v-if="newTitle.trim() === ''">
                            The title cannot be empty!
                        </span>

                        </div>
                    </div>
                </div>
            </div>
            <div class="row">&nbsp;</div>
            <subtitle-translated-localization-cue
                    v-for="(cue, number) in masterCues"
                    :number="number"
                    :key="number"
                    :master-lines="cue"
                    :localized-lines="localizedCues[number]"
                    :translated-lines="translatedCues[number]"
                    :locked="isLocked(number)">
            </subtitle-translated-localization-cue>

            <div class="row">
                <div class="col-xs-6">
                    <button class="btn btn-default"
                            name="submit-save"
                            @click.prevent="save('Saved')">
                        <strong>Save</strong>
                    </button>
                </div>

                <div class="col-xs-6 text-right">
                    <submit-button></submit-button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    require('../../../vendor/jquery/plugins/diff_match_patch/javascript/diff_match_patch')
    require('../../../vendor/jquery/plugins/preetyTextDiff/jquery.pretty-text-diff.min')
    let _ = require('lodash')
    let toastr = require('toastr')

    export default {
        props: [
            'masterCuesJson',
            'localizedCuesJson',
            'translatedCuesJson',
            'changedCuesJson',
            'saveRoute',
            'masterTitle',
            'localizedTitle',
            'translatedTitle',
        ],

        data: function() {
            return {
                csrfToken: window.csrfToken,
                newTitle: this.translatedTitle,
                titleIsLocked: this.masterTitle.trim() === this.localizedTitle.trim(),
                autosaveCache: '',
            }
        },

        computed: {
            masterCues: function() {
                return JSON.parse(this.masterCuesJson)
            },
            localizedCues: function() {
                return JSON.parse(this.localizedCuesJson)
            },
            translatedCues: function() {
                return JSON.parse(this.translatedCuesJson)
            },
            changedCues: function() {
                return JSON.parse(this.changedCuesJson)
            },
        },

        mounted() {
            this.autosaveCache = $(this.$refs.form).serialize();
            this.autosaveTimer()
            $('#diff-wrapper-title').prettyTextDiff({
                originalContent: $('#original-title').html(),
                changedContent: $('#changed-title').html(),
                diffContainer: '.diff-title',
                debug: false,
            })
        },

        methods: {
            toggleLock() {
                this.titleIsLocked = !this.titleIsLocked
            },

            autosaveTimer() {
                setTimeout(() => {
                    this.autosave()
                    this.autosaveTimer()
                }, 60000) // once per minute
            },

            autosave() {
                // only autosave if form data has changed since last save
                if (this.autosaveCache !== $(this.$refs.form).serialize()) {
                    this.save('Auto saved');
                }
            },

            save(message) {
                let formData = $(this.$refs.form).serialize()

                window.axios.post(this.saveRoute, formData).then(() => {
                    this.autosaveCache = formData;
                    toastr.success(message)
                }).catch(() => {
                    toastr.error('Something went wrong...', message)
                })
            },

            isLocked: function(cueNumber) {
                return this.changedCues.indexOf(cueNumber) === -1
            },
        },
    }
</script>
